import type { DefaultsInstance } from 'vuetify'
import { heilandColors } from './colors'

const heilandDefault: DefaultsInstance = {
  VBtnTogglePrimary: {
    // VBtnToggle uses VSlideGroup; after Vuetify 3.12 overflow detection can
    // intermittently show scroll arrows for short toggles (e.g. Office/Pharmacy).
    showArrows: false,
    style: `border-radius: 8px;background-color: ${heilandColors['vm-grey-2']}`,
    class: 'btn-toggle-primary',
    VBtn: {
      color: heilandColors['vm-grey-9'],
      style: 'border-radius: 8px;letter-spacing: 0 !important;',
    },
  },
}

export default heilandDefault
